﻿import React from 'react';
import styled from 'styled-components';

import { mediaQuery, iconCode } from '../Style/cssHelpers';
import definitions from '../Style/LfStyleDefinitions';

class InfoBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { helpTextVisibility: false };
    }

    closeHelpText = (e) => {
        e.stopPropagation();
        e.preventDefault();

        document.body.removeEventListener('click', this.closeHelpText, false);
        this.setState({ helpTextVisibility: false });
    }

    toggleHelpText = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const helpTextVisibility = this.state.helpTextVisibility;

        if (!helpTextVisibility) {
            document.body.addEventListener('click', this.closeHelpText);
        }

        this.setState({ helpTextVisibility: !helpTextVisibility });
    }

    render() {
        return (
            <InfoBoxWrapper helpTextVisibility={this.state.helpTextVisibility} marginTop={this.props.marginTop} contentFontSize={this.props.fontSize} top={this.props.top}>
                <button
                    type="button"
                    className="helpTextIcon"
                    onClick={e => this.toggleHelpText(e)}
                >
                    <span>Se ordförklaring.</span>
                </button>
                <span className="helpText">
                    <span className="helpTextArrow">&nbsp;</span>
                    <span className="helpTextContent">{this.props.children}</span>
                </span>
            </InfoBoxWrapper>
        );
    }
}

export default InfoBox;

// styled components

const infoBoxPropsToExclude = ['marginTop', 'top', 'helpTextVisibility', 'contentFontSize'];

const InfoBoxWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !infoBoxPropsToExclude.includes(prop)
})`
    position: relative;
    display: inline-block;
    font-weight: normal;

    ${mediaQuery.small(`
        display: inline;
    `)}

    .helpTextIcon {
        background: none;
        border: 0;
        box-sizing: content-box;
        cursor: pointer;
        color: ${definitions.colors.blueBackground};
        height: 1em;

        margin-top: ${props => props.marginTop ? props.marginTop : '0'}px;
        ${props => props.top ? 'top:' + props.top + 'px' : ''};


        transition: all 3s ease-in-out;

        &:after {
            font-size: initial;
            font-weight: normal;
            ${iconCode.informationIcon()}
            position: relative;
            top: 1.5px;
            left: 5px;
            ${mediaQuery.small(`
                top: 1px;
                left: -1px;
            `)}
            ${mediaQuery.xxsmall(`
                font-size: 12px;
                top: -1px;
            `)}
        }

        &:hover {
            color: #23527c;
        }

        span {
            display: none;
        }
    }

    .helpText {
        display: ${props => props.helpTextVisibility === true ? 'block' : 'none'};
        position: absolute;
        top: 15px;
        left: -207px;
        padding-top: 5px;
        z-index: 1;

        ${mediaQuery.small(`
            position: relative;
            top: 5px;
            left: 0px;
            height: 0px;
            padding: 0px;
            width: 0px;
        `)}

        .helpTextArrow {
            display: block;
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 11px solid ${definitions.colors.blueBackground};
            margin: 0px auto -1px auto;

            ${mediaQuery.small(`
                display: none;
            `)}
        }

        .helpTextContent {
            background-color: ${definitions.colors.blueBackground};
            color: #fff;
            display: block;
            text-align: left;
            border-radius: 10px;
            padding: 15px 15px;
            margin: 0px auto;
            width: 430px;
            line-height: 1.3;
            box-shadow: -1px 4px 10px -1px rgba(0,0,0,0.4);

            ${props => props.contentFontSize ? 'font-size:' + props.contentFontSize + 'px' : ''};


            ${mediaQuery.small(`
                padding: 15px 20px;
                width: 80vw;
                position: absolute;
            `)}
        }
    }
`;